import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import {
  SortingState, SelectionState, GroupingState, SearchState,
  IntegratedFiltering, IntegratedGrouping, IntegratedSorting, IntegratedSelection,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable, TableHeaderRow, TableSelection, TableGroupRow,
  GroupingPanel, DragDropProvider, Toolbar, SearchPanel,
} from '@devexpress/dx-react-grid-material-ui';
import MuiGrid from '@material-ui/core/Grid';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setSelectedProperties } from '../../../store/features/propertiesTable';

const columns = [
  { title: 'Display Name', name: 'displayName' },
  { title: 'Address', name: 'address'},
  { title: 'Variant', name: 'variant' },
  { title: 'DARs Required', name: 'darsRequired' },
  { title: 'VIP Status', name: 'cardinal' },
  { title: 'Actions', name: 'actions' }
];

const PropertiesTable = ({ data }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selected = useSelector(state => state.propertiesTable.selectedProperties);
  const [ columnAlignment ] = useState([
    { columnName: 'actions', align: 'right'},
  ]);
  const [sortingStateColumnExtensions] = useState([
    { columnName: 'actions', sortingEnabled: false },
  ]);
  const [groupingStateColumnExtensions] = useState([
    { columnName: 'actions', groupingEnabled: false },
    { columnName: 'formattedAddress', groupingEnabled: false },
  ]);
  
  return (
    <MuiGrid className={classes.root} container>
      <MuiGrid item xs={12}>
        <Paper>
          <Grid
            rows={data}
            columns={columns}
            getRowId={row => row.id}
          >
            <DragDropProvider />
            <SearchState />
            <SortingState 
              defaultSorting={[
                { columnName: 'displayName', direction: 'asc' }
              ]}
              columnExtensions={sortingStateColumnExtensions}
            />
            <GroupingState 
              columnExtensions={groupingStateColumnExtensions}
            />
            <SelectionState 
              onSelectionChange={(e) => dispatch(setSelectedProperties({ selectedProperties: e }))}
              selection={selected}
            />
            <IntegratedFiltering />
            <IntegratedSorting />
            <IntegratedGrouping />
            <IntegratedSelection />
            <VirtualTable
              cellComponent={props => <VirtualTable.Cell {...props} />}
              columnExtensions={columnAlignment}
            />
            <TableHeaderRow showSortingControls />
            <TableSelection showSelectAll />
            <TableGroupRow />
            <Toolbar />
            <SearchPanel />
            <GroupingPanel showSortingControls />
          </Grid>
        </Paper>
      </MuiGrid>
    </MuiGrid>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 24,
    marginBottom: 24
  },
}));

export default PropertiesTable;